<template>
  <div class="container p-0 texto-principal">
    <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
      <img src="@/assets/LOADING.gif" style="width: 60px;" alt="Cargando..." />
    </div>
    <div v-if="!loading && (hasVerHorariosPermission || hasVerMisHorariosYFichadasPermission)" class="w-100 mb-4">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 w-100 gap-3 px-1">
        <div class="d-flex align-items-center gap-3">
          <h5 class="text-start m-0 ms-1 d-flex align-items-center gap-2">
            <i class="bi bi-clock-history"></i>
            {{ t('horarios') }} 
          </h5>
          <div v-if="hasManejarHorariosPermission && !esPerfilPropio" class="dropdown shadow-sm p-0 rounded-3">
            <button class="btn bg-goethe-accent sombra p-1 rounded-3 d-flex align-items-center justify-content-center" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 12H18M12 6V18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            
            <ul class="dropdown-menu fondo-terciario texto-principal borde-secundario shadow">
              <li style="cursor: pointer;">
                <a class="dropdown-item texto-secundario d-flex align-items-center gap-2 py-2" @click="abrirModalNuevo('horario')">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-principal" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                  {{ t('horario') }}
                </a>
              </li>
              <li style="cursor: pointer;">
                <a class="dropdown-item texto-secundario d-flex align-items-center gap-2 py-2" @click="abrirModalNuevo('vacaciones')">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-principal" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
                  {{ t('vacaciones') }}
                </a>
              </li>
              <li style="cursor: pointer;">
                <a class="dropdown-item texto-secundario d-flex align-items-center gap-2 py-2" @click="abrirModalNuevo('receso')">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-principal" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line></svg>
                  {{ t('horarioDeReceso') }}
                </a>
              </li>
              <li style="cursor: pointer;">
                <a class="dropdown-item texto-secundario d-flex align-items-center gap-2 py-2" @click="abrirModalNuevo('licenciaEspecial')">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal"><path d="M2 9C2 7.89543 2.89543 7 4 7H20C21.1046 7 22 7.89543 22 9V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V9Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 7V4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4V7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M22 12L12.3922 13.9216C12.1333 13.9733 11.8667 13.9733 11.6078 13.9216L2 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  {{ t('licenciaEspecial') }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div v-if="!noTieneHorariosNiFichadas" class="d-flex flex-column">
          <div class="d-flex align-items-center justify-content-end gap-2 w-100">
            <button class="btn fondo-terciario texto-principal sombra-sm d-flex align-items-center rounded-3" :class="{ 'disabled opacity-50': !puedeRetroceder }" @click.prevent="puedeRetroceder && cambiarPeriodo(-1)" style="height: 39px;">
              <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)">
                <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div>
              <input type="date" class="form-control form-control-sm sombra-sm p-2 rounded-3" v-model="periodoFiltroDesdeTemp"/>
            </div>
            <p class="m-0">{{ $t('al') }}</p>
            <div>
              <input type="date" class="form-control form-control-sm sombra-sm p-2 rounded-3" v-model="periodoFiltroHastaTemp"/>
            </div>
            <button class="btn fondo-terciario texto-principal sombra-sm d-flex align-items-center rounded-3" :class="{ 'disabled opacity-50': !puedeAvanzar }" @click.prevent="puedeAvanzar && cambiarPeriodo(+1)" style="height: 39px;">
              <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <p v-if="errorPeriodoMaximo31Dias" class="m-0 texto-rojo fs-8 ms-auto">{{ $t('errorPeriodoMaximo31Dias') }}</p>
          <p v-if="errorDesdeNoMayorHasta" class="m-0 texto-rojo fs-8 ms-auto">{{ $t('errorDesdeNoMayorHasta') }}</p>
        </div>
      </div>

      <div v-if="!noTieneHorariosNiFichadas" class="w-100 pb-2">
        <div :style="{ display: 'grid', gridTemplateColumns: `repeat(${cantidadColumnas}, minmax(0, 1fr))`, gap: '0.5rem' }" class="p-1">
          <div v-for="dia in fechasAVisualizar" :key="dia.fecha"
              class="rounded sombra-sm p-2 d-flex flex-column"
              :class="!(dia.fecha >= periodoFiltroDesde && dia.fecha <= periodoFiltroHasta) ? 'fondo-secundario' : 'fondo-terciario'">
            
            <div v-if="dia.fecha >= periodoFiltroDesde && dia.fecha <= periodoFiltroHasta" class="text-center mb-3 pb-2 border-bottom borde-secundario">
              <div class="fw-bold texto-principal">{{ t(dia.nombre) }}</div>
              <div class="small texto-secundario">{{ dia.fechaCorta }}</div>
            </div>

            <div v-if="dia.fecha >= periodoFiltroDesde && dia.fecha <= periodoFiltroHasta" class="d-flex flex-column gap-2 text-start w-100 flex-grow-1">
              <div 
                v-for="item in obtenerHorariosBO(dia.id, dia.fecha)" 
                :key="item.IdHorario"
                :class="[ 'fondo-terciario texto-principal border-start border-4 rounded p-2 sombra w-100 position-relative', item.EsVacaciones ? 'borde-violeta-3' : (item.TipoLicencia != null ? 'borde-violeta-3' : (item.EsHomeOffice ? 'borde-azul-3' : 'borde-verde-3')) ]"
              >
                <div v-if="hasAdminHorariosPermission" class="dropdown position-absolute top-0 end-0 mt-1">
                  <button class="btn p-1 border-0 d-flex align-items-center justify-content-center texto-secundario" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="stroke-principal" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="1"></circle>
                      <circle cx="12" cy="5" r="1"></circle>
                      <circle cx="12" cy="19" r="1"></circle>
                    </svg>
                  </button>
                  
                  <ul class="dropdown-menu dropdown-menu-end fondo-terciario texto-principal borde-secundario shadow">
                    <li style="cursor: pointer;">
                      <a class="dropdown-item texto-secundario d-flex align-items-center gap-2 py-2" @click="abrirModalEditar(item)">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-principal" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                        </svg>
                        {{ t('editar') }}
                      </a>
                    </li>

                    <li style="cursor: pointer;">
                      <a class="dropdown-item text-danger d-flex align-items-center gap-2 py-2" @click="eliminarHorario(item.IdHorario)">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="3 6 5 6 21 6"></polyline>
                          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        </svg>
                        {{ t('eliminar') }}
                      </a>
                    </li>
                  </ul>
                </div>
                
                <div class="d-flex align-items-center gap-1 flex-wrap pe-4">
                  <span v-if="item.EsVacaciones" class="badge fondo-violeta-3 sombra-sm texto-principal">{{ t('Vacaciones') }}</span>
                  <span v-else-if="item.TipoLicencia" class="badge fondo-violeta-3 sombra-sm texto-principal">{{ t(item.TipoLicencia) }}</span>
                  <span v-else :class="['badge', item.EsHomeOffice ? 'fondo-azul-3 ' : 'fondo-verde-3']" class="sombra-sm texto-principal">{{ $t(item.EsHomeOffice ? 'homeOffice' : 'presencial') }}</span>
                </div>
                
                <div v-if="!item.TipoLicencia" class="fw-bold mt-2 text-wrap">
                  {{ formatearHora(item.HoraDesde) }} - {{ formatearHora(item.HoraHasta) }}
                </div>

                <div v-if="item.TipoLicencia" class="mt-2 d-flex align-items-center justify-content-between gap-2">
                  <div class="small fs-7 texto-secundario d-flex align-items-center gap-1">
                    <i class="bi bi-file-earmark-text"></i>
                    <a v-if="item.Certificado" :href="item.Certificado" target="_blank" class="text-decoration-none texto-principal fw-bold">
                      {{ t('verCertificado') }}
                    </a>
                    <svg width="15" height="15" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path id="Vector" d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span v-if="!item.Certificado" class="ms-1 italic">{{ t('sinCertificado') }}</span>
                  </div>
                      
                  <div class="d-flex align-items-center gap-1">
                    <button v-if="item.Certificado && hasManejarHorariosPermission && !esPerfilPropio"
                      type="button" 
                      class="btn p-0 border-0 fondo-rojo-3 ms-1 px-1" 
                      :disabled="guardandoIds.includes(item.IdHorario)"
                      @click.prevent="eliminarCertificado(item)"
                    >
                      <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                        <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>

                    <div v-if="!item.Certificado && hasManejarHorariosPermission && !esPerfilPropio">
                      <input 
                        type="file" 
                        :id="'file-' + item.IdHorario" 
                        class="d-none" 
                        accept=".pdf,.png,.jpg,.jpeg"
                        @change="onFileSelected($event, item)"
                      />
                      <label 
                        :for="'file-' + item.IdHorario" 
                        class="btn btn-xs btn-outline-secondary py-0 px-2 rounded-2 shadow-sm"
                        :class="{ 'disabled opacity-50': guardandoIds.includes(item.IdHorario) }"
                        title="Subir certificado"
                      >
                        <i v-if="guardandoIds.includes(item.IdHorario)" class="spinner-border spinner-border-sm" role="status"></i>
                        <i v-else class="bi bi-paperclip fs-6"></i>
                      </label>
                    </div>
                  </div>
                </div>
                </div>

              <div v-if="obtenerHorariosBO(dia.id, dia.fecha).length === 0" class="texto-secundario small text-center mt-2 w-100">
                -
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loading && (hasVerFichadasPermission || hasVerMisHorariosYFichadasPermission) && !noTieneHorariosNiFichadas" class="table-responsive w-100">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 w-100 px-1">
        <h5 class="text-start m-0 ms-1 d-flex align-items-center gap-2">
          <i class="bi bi-fingerprint fs-4"></i>
          {{ t('fichadas') }} 
        </h5>

        <div class="d-flex flex-column">
          <div class="d-flex align-items-center justify-content-end gap-2">
            <button class="btn fondo-terciario texto-principal sombra-sm d-flex align-items-center rounded-3" :class="{ 'disabled opacity-50': !puedeRetroceder }" @click.prevent="puedeRetroceder && cambiarPeriodo(-1)" style="height: 39px;">
              <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)">
                <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div>
              <input type="date" class="form-control form-control-sm sombra-sm p-2 rounded-3" v-model="periodoFiltroDesdeTemp" />
            </div>
            <p class="m-0">{{ $t('al') }}</p>
            <div>
              <input type="date" class="form-control form-control-sm sombra-sm p-2 rounded-3" v-model="periodoFiltroHastaTemp" />
            </div>
            <button class="btn fondo-terciario texto-principal sombra-sm d-flex align-items-center rounded-3" :class="{ 'disabled opacity-50': !puedeAvanzar }" @click.prevent="puedeAvanzar && cambiarPeriodo(+1)" style="height: 39px;">
              <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <p v-if="errorPeriodoMaximo31Dias" class="m-0 texto-rojo fs-8 ms-auto">{{ $t('errorPeriodoMaximo31Dias') }}</p>
          <p v-if="errorDesdeNoMayorHasta" class="m-0 texto-rojo fs-8 ms-auto">{{ $t('errorDesdeNoMayorHasta') }}</p>
        </div>
      </div>

      <div class="w-100 pb-2">
        <div :style="{ display: 'grid', gridTemplateColumns: `repeat(${cantidadColumnas}, minmax(0, 1fr))`, gap: '0.5rem' }" class="p-1">
          <div v-for="dia in fechasAVisualizar" :key="dia.fecha"
              class="rounded sombra-sm p-2 d-flex flex-column"
              :class="!(dia.fecha >= periodoFiltroDesde && dia.fecha <= periodoFiltroHasta) ? 'fondo-secundario' : 'fondo-terciario'">
            
            <div v-if="dia.fecha >= periodoFiltroDesde && dia.fecha <= periodoFiltroHasta" class="text-center mb-3 pb-2 border-bottom borde-secundario">
              <div class="fw-bold texto-principal">{{ t(dia.nombre) }}</div>
              <div class="small texto-secundario">{{ dia.fechaCorta }}</div>
            </div>

            <div v-if="dia.fecha >= periodoFiltroDesde && dia.fecha <= periodoFiltroHasta" class="d-flex flex-column gap-2 text-start w-100 flex-grow-1">
              <div v-for="evaluacion in obtenerResumenDia(dia.fecha)?.Evaluacion" :key="evaluacion.Id">
                <div v-if="!esPerfilPropio || evaluacion.Color == 'violeta' || evaluacion.Color == 'gris' || evaluacion.Color == 'azul'" class="mb-1 text-center"> <span :class="['badge w-100 py-2 texto-principal text-wrap', 'fondo-'+evaluacion.Color+'-3']">
                    {{ t(evaluacion.Texto) }}
                  </span>
                </div>
              </div>
              
              <div 
                v-for="fichada in obtenerResumenDia(dia.fecha)?.Fichadas || []" 
                :key="fichada.IdFichada"
                :class="[ 'fondo-terciario texto-principal border-start border-4 rounded p-2 w-100 sombra', 'borde-'+fichada.Color+'-3' ]"
              >
                <div class="d-flex align-items-center gap-2">
                  <div class="fw-bold fs-5">
                    {{ fichada.Hora }}
                  </div>
                </div>
                
                <div class="d-flex align-items-center mt-1">
                  <span class="badge fondo-secundario texto-principal sombra-sm text-wrap">
                    Reloj: {{ reloj[fichada.IdReloj-1]?.nombre || $t('desconocido') }}
                  </span>
                </div>
              </div>

              <div v-if="(obtenerResumenDia(dia.fecha)?.Fichadas || []).length === 0" class="texto-secundario small text-center mt-2 w-100">
                -
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModal && hasManejarHorariosPermission" class="modal-backdrop-custom d-flex align-items-center justify-content-center">
      <div class="sombra-sm w-100 border-0 rounded-4 overflow-auto texto-secundario" style="max-width: 450px;">
        <div class="fondo-secundario d-flex justify-content-between align-items-center p-3 pb-0">
          <h6 class="m-0 fw-bold">{{ isEditing ? t('editar') + ' ' + $t(formData.Nombre) : t('nuevo') + ' ' + $t(formData.Nombre) }}</h6>
          <button type="button" class="btn p-0" @click="cerrarModal">
            <svg width="20" height="20" viewBox="5 5 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
                <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
              </g>
            </svg>
          </button>
        </div>
        <div class="fondo-secundario p-3">
          <form @submit.prevent="guardarHorario">
            
            <div class="mb-3" v-if="!formData.EsVacaciones && formData.TipoLicencia == null">
              <label class="form-label small fw-bold">{{ t('diaDeLaSemana') }}</label>
              <div class="select-wrapper w-100 home-list">
                <select v-model="formData.Dia" required class="form-select texto-secundario border-0 cursor-pointer w-100 fondo-terciario">
                  <option v-if="!isEditing" :value="0">{{ t('todosLosDiasHabiles') }}</option>
                  <option v-for="dia in diasSemana" :value="dia.id" :key="dia.id">{{ t(dia.nombre) }}</option>
                </select>
                <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                </svg>
              </div>
            </div>

            <div class="mb-3" v-if="!formData.EsVacaciones && formData.TipoLicencia != null">
              <label class="form-label small fw-bold">{{ t('tipoLicencia') }}</label>

              <div class="select-wrapper w-100 home-list">
                <select v-model="formData.TipoLicencia" required class="form-select texto-secundario border-0 cursor-pointer w-100 fondo-terciario">
                <option value="">{{ t('Seleccionar tipo') }}</option>
                <option value="diaExamen">{{ t('diaExamen') }}</option>
                <option value="diaEstudio">{{ t('diaEstudio') }}</option>
                <option value="enfermedad">{{ t('enfermedad') }}</option>
                <option value="embarazo">{{ t('embarazo') }}</option>
                </select>
                <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                </svg>
              </div>
            </div>

            <div class="row" v-if="!formData.EsVacaciones && formData.TipoLicencia == null">
              <div class="col-6 mb-3">
                <label class="form-label small fw-bold">{{ t('horaDesde') }}</label>
                <input type="time" class="form-control sombra-sm" v-model="formData.HoraDesde" required />
              </div>
              <div class="col-6 mb-3">
                <label class="form-label small fw-bold">{{ t('horaHasta') }}</label>
                <input type="time" class="form-control sombra-sm" v-model="formData.HoraHasta" required />
              </div>
            </div>

            <div class="row">
              <div class="col-6 mb-3">
                <label class="form-label small fw-bold">{{ t('periodoDesde') }}</label>
                <input type="date" class="form-control sombra-sm" v-model="formData.PeriodoDesde" required />
              </div>
              <div class="col-6 mb-3">
                <label class="form-label small fw-bold">{{ t('periodoHasta') }} <span v-if="!formData.EsVacaciones && formData.TipoLicencia == null">({{ t('opcional') }})</span></label>
                <input type="date" class="form-control sombra-sm" v-model="formData.PeriodoHasta" />
              </div>
            </div>

            <!-- <hr class="texto-secundario" /> -->

            <div class="d-flex flex-column gap-2 mb-4" v-if="!formData.EsVacaciones && formData.TipoLicencia == null">
              <div class="form-check">
                <input 
                  class="form-check-input" 
                  type="checkbox" 
                  id="checkHomeOffice" 
                  v-model="formData.EsHomeOffice"
                  @change="handleHomeOfficeChange"
                >
                <label class="form-check-label" for="checkHomeOffice">
                  {{ t('esHomeOffice') }}
                </label>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-secondary" @click="cerrarModal">{{ t('cancelar') }}</button>
              <button type="submit" class="btn btn-primary" :disabled="guardando">
                <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
                {{ t('guardar') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="noTieneHorariosNiFichadas">
      <p>{{ t('niHorariosNiFichadas') }}</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, reactive, watch } from 'vue';
import { useStore } from "vuex";
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'HorariosBackOfficeSection',
  props: {
    persona: {
      type: Object,
      required: true
    },
    esPerfilPropio: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { t } = useI18n();
    const loading = ref(false);
    const errorPeriodoMaximo31Dias = ref(false);
    const errorDesdeNoMayorHasta = ref(false);
    const store = useStore();
    const user = computed(() => store.state.user);
    
    const listaHorariosBackOffice = ref([]);
    const resumenSemana = ref([]); 
    
    const guardandoIds = ref([]); // Control de loading por ID al subir/eliminar certificado

    const parseDateLocal = (dateStr) => {
      const [year, month, day] = dateStr.split('-');
      return new Date(year, month - 1, day);
    };
    
    const formatDateLocal = (dateObj) => {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const obtenerLunes = (fecha) => {
      const d = new Date(fecha);
      const diaDeLaSemana = d.getDay() === 0 ? 7 : d.getDay();
      d.setDate(d.getDate() - diaDeLaSemana + 1);
      return d;
    };

    const hoy = new Date();
    const lunesInicial = obtenerLunes(hoy);
    const domingoInicial = new Date(lunesInicial);
    domingoInicial.setDate(lunesInicial.getDate() + 6);

    const storedDesde = localStorage.getItem('filtroPeriodoDesdeRRHH');
    const storedHasta = localStorage.getItem('filtroPeriodoHastaRRHH');

    const periodoFiltroDesde = ref(storedDesde || formatDateLocal(lunesInicial));
    const periodoFiltroHasta = ref(storedHasta || formatDateLocal(domingoInicial));

    const periodoFiltroDesdeTemp = ref(storedDesde || formatDateLocal(lunesInicial));
    const periodoFiltroHastaTemp = ref(storedHasta || formatDateLocal(domingoInicial));

    const showModal = ref(false);
    const isEditing = ref(false);
    const guardando = ref(false);
    
    var hasVerHorariosPermission = ref(false);
    var hasManejarHorariosPermission = ref(false);
    var hasVerFichadasPermission = ref(false);
    var hasAdminHorariosPermission = ref(false);
    var hasVerMisHorariosYFichadasPermission = ref(false);

    var noTieneHorariosNiFichadas = ref(false);

    const formData = reactive({
      IdHorario: null,
      Dia: 1,
      HoraDesde: '',
      HoraHasta: '',
      PeriodoDesde: '',
      PeriodoHasta: '',
      EsHomeOffice: false,
      EsVacaciones: false,
      TipoLicencia: null
    });

    const diasSemana = [
      { id: 1, nombre: 'Lunes' },
      { id: 2, nombre: 'Martes' },
      { id: 3, nombre: 'Miercoles' },
      { id: 4, nombre: 'Jueves' },
      { id: 5, nombre: 'Viernes' },
      { id: 6, nombre: 'Sábado' },
      { id: 7, nombre: 'Domingo' }
    ];

    const reloj = [
      { id: 1, nombre: 'Reclus' },
      { id: 2, nombre: 'Montevideo' },
      { id: 3, nombre: 'Primaria' },
    ];
    
    const checkAuth = async () => {
      var permisoAComprobar = 'VerHorarios'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        hasVerHorariosPermission.value = true;
      }
      permisoAComprobar = 'ManejarHorarios'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        hasManejarHorariosPermission.value = true;
      }
      permisoAComprobar = 'VerFichadas'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        hasVerFichadasPermission.value = true;
      }

      permisoAComprobar = 'AdminHorarios'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) ||
          user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
          hasAdminHorariosPermission.value = true;
      }
      permisoAComprobar = 'VerMisHorariosYFichadas'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
      {
        if(props.persona.IdPersona === user.value.idPersona){
          hasVerMisHorariosYFichadasPermission.value = true;
        }
      }
    };

    // Funciones para Certificados
    const onFileSelected = async (event, item) => {
      const file = event.target.files[0];
      if (!file) return;

      guardandoIds.value.push(item.IdHorario);
      const data = new FormData();
      data.append('archivo', file); 

      try {
        await api.post(`api/horarios/${item.IdHorario}/certificado`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        await fetchDatos(); // Recargar datos para traer la URL del certificado actualizado
      } catch (error) {
        console.error('Error al subir certificado:', error);
        alert(t('Error al subir el certificado.'));
      } finally {
        guardandoIds.value = guardandoIds.value.filter(id => id !== item.IdHorario);
        event.target.value = null; 
      }
    };

    const eliminarCertificado = async (item) => {
      if (!confirm(t('¿Está seguro de que desea eliminar este certificado?'))) return;

      guardandoIds.value.push(item.IdHorario);
      try {
        await api.delete(`api/horarios/${item.IdHorario}/certificado`);
        await fetchDatos(); // Recargar la información del servidor
      } catch (error) {
        console.error('Error al eliminar certificado:', error);
        alert(t('Error al eliminar el certificado.'));
      } finally {
        guardandoIds.value = guardandoIds.value.filter(id => id !== item.IdHorario);
      }
    };

    const cantidadDiasPeriodo = computed(() => {
      const d1 = parseDateLocal(periodoFiltroDesde.value);
      const d2 = parseDateLocal(periodoFiltroHasta.value);
      const diffTime = Math.abs(d2 - d1);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    });

    const puedeAvanzar = computed(() => true); 
    const puedeRetroceder = computed(() => {
      const hace6meses = new Date();
      hace6meses.setMonth(hace6meses.getMonth() - 6);
      return parseDateLocal(periodoFiltroDesde.value) >= hace6meses;
    });

    const fechasAVisualizar = computed(() => {
      const fechasPeriodo = [];
      const inicio = parseDateLocal(periodoFiltroDesde.value);
      const dias = cantidadDiasPeriodo.value;
      const columnas = cantidadColumnas.value;

      for (let i = 0; i < dias; i++) {
        const d = new Date(inicio);
        d.setDate(inicio.getDate() + i);

        const mes = String(d.getMonth() + 1).padStart(2, '0');
        const dia = String(d.getDate()).padStart(2, '0');
        const fechaString = `${d.getFullYear()}-${mes}-${dia}`;
        const diaSemana = d.getDay() === 0 ? 7 : d.getDay();

        const resumenDia = resumenSemana.value.find(r => r.Fecha === fechaString);
        const tieneData = resumenDia && resumenDia.Fichadas && resumenDia.Fichadas.length > 0;
        const esValido = diaSemana < 6 || tieneData;

        if (diaSemana <= columnas) {
          fechasPeriodo.push({
            dateObj: d,
            id: diaSemana,
            nombre: diasSemana.find(ds => ds.id === diaSemana)?.nombre || '',
            fecha: fechaString,
            fechaCorta: `${dia}/${mes}`,
            esValido: esValido
          });
        }
      }

      let primerIndice = -1;
      let ultimoIndice = -1;
      for (let i = 0; i < fechasPeriodo.length; i++) {
        if (fechasPeriodo[i].esValido) {
          if (primerIndice === -1) primerIndice = i;
          ultimoIndice = i;
        }
      }

      if (primerIndice === -1) return [];

      const fechasRecortadas = fechasPeriodo.slice(primerIndice, ultimoIndice + 1);
      const resultadoFinal = [];
      const primerDia = fechasRecortadas[0];

      if (primerDia.id > 1) {
        for (let i = 1; i < primerDia.id; i++) {
          const d = new Date(primerDia.dateObj);
          d.setDate(primerDia.dateObj.getDate() - (primerDia.id - i));
          
          const mes = String(d.getMonth() + 1).padStart(2, '0');
          const dia = String(d.getDate()).padStart(2, '0');
          resultadoFinal.push({
            id: i,
            nombre: diasSemana.find(ds => ds.id === i)?.nombre || '',
            fecha: `${d.getFullYear()}-${mes}-${dia}`,
            fechaCorta: `${dia}/${mes}`
          });
        }
      }

      fechasRecortadas.forEach(f => {
        resultadoFinal.push({
          id: f.id,
          nombre: f.nombre,
          fecha: f.fecha,
          fechaCorta: f.fechaCorta
        });
      });

      const ultimoDia = resultadoFinal[resultadoFinal.length - 1];
      if (ultimoDia.id < columnas) {
        const dObj = parseDateLocal(ultimoDia.fecha);
        for (let i = ultimoDia.id + 1; i <= columnas; i++) {
          const d = new Date(dObj);
          d.setDate(d.getDate() + (i - ultimoDia.id));
          
          const mes = String(d.getMonth() + 1).padStart(2, '0');
          const dia = String(d.getDate()).padStart(2, '0');
          resultadoFinal.push({
            id: i,
            nombre: diasSemana.find(ds => ds.id === i)?.nombre || '',
            fecha: `${d.getFullYear()}-${mes}-${dia}`,
            fechaCorta: `${dia}/${mes}`
          });
        }
      }

      return resultadoFinal;
    });

    const cantidadColumnas = computed(() => {
      let maxCols = 5;
      const inicio = parseDateLocal(periodoFiltroDesde.value);
      const dias = cantidadDiasPeriodo.value;

      for (let i = 0; i < dias; i++) {
        const d = new Date(inicio);
        d.setDate(inicio.getDate() + i);
        const diaSemana = d.getDay() === 0 ? 7 : d.getDay();

        if (diaSemana === 6 || diaSemana === 7) {
          const mes = String(d.getMonth() + 1).padStart(2, '0');
          const dia = String(d.getDate()).padStart(2, '0');
          const fechaString = `${d.getFullYear()}-${mes}-${dia}`;
          
          const resumenDia = resumenSemana.value.find(r => r.Fecha === fechaString);
          const tieneData = resumenDia && resumenDia.Fichadas && resumenDia.Fichadas.length > 0;
          
          if (tieneData) {
            maxCols = Math.max(maxCols, diaSemana);
            if (maxCols === 7) break; 
          }
        }
      }
      return maxCols;
    });

    const cambiarPeriodo = async (direccion) => {
      if (direccion === 1 && !puedeAvanzar.value) return;
      if (direccion === -1 && !puedeRetroceder.value) return;

      const dDesde = parseDateLocal(periodoFiltroDesdeTemp.value);
      const dHasta = parseDateLocal(periodoFiltroHastaTemp.value);
      
      const diaInicio = dDesde.getDate();
      const diaFin = dHasta.getDate();
      
      const ultimoDiaMesActual = new Date(dDesde.getFullYear(), dDesde.getMonth() + 1, 0).getDate();

      const esPrimeraQuincena = diaInicio === 1 && diaFin === 15;
      const esSegundaQuincena = diaInicio === 16 && diaFin === ultimoDiaMesActual;
      const esMesCompleto = diaInicio === 1 && diaFin === ultimoDiaMesActual;

      if (esMesCompleto) {
        dDesde.setMonth(dDesde.getMonth() + direccion, 1);
        dHasta.setFullYear(dDesde.getFullYear(), dDesde.getMonth() + 1, 0);
      } else if (esPrimeraQuincena || esSegundaQuincena) {
        if (direccion === 1) { 
          if (esPrimeraQuincena) {
            dDesde.setDate(16);
          } else {
            dDesde.setMonth(dDesde.getMonth() + 1, 1);
          }
        } else { 
          if (esSegundaQuincena) {
            dDesde.setDate(1);
          } else {
            dDesde.setMonth(dDesde.getMonth() - 1, 16);
          }
        }
        
        if (dDesde.getDate() === 1) {
          dHasta.setFullYear(dDesde.getFullYear(), dDesde.getMonth(), 15);
        } else {
          dHasta.setFullYear(dDesde.getFullYear(), dDesde.getMonth() + 1, 0);
        }

      } else {
        const dias = cantidadDiasPeriodo.value * direccion;
        dDesde.setDate(dDesde.getDate() + dias);
        dHasta.setDate(dHasta.getDate() + dias);
      }

      periodoFiltroDesde.value = formatDateLocal(dDesde);
      periodoFiltroHasta.value = formatDateLocal(dHasta);

      periodoFiltroDesdeTemp.value = formatDateLocal(dDesde);
      periodoFiltroHastaTemp.value = formatDateLocal(dHasta);

      await fetchResumenSemana();
    };

    const aplicarFiltroPersonalizado = async (newDesde, newHasta, oldDesde, oldHasta) => {
      if (!periodoFiltroDesdeTemp.value || !periodoFiltroHastaTemp.value) {
        return;
      }

      const fDesde = parseDateLocal(periodoFiltroDesdeTemp?.value);
      const fHasta = parseDateLocal(periodoFiltroHastaTemp?.value);

      if (isNaN(fDesde.getTime()) || isNaN(fHasta.getTime())) {
        return;
      }
      
      if (fDesde > fHasta) {
        errorDesdeNoMayorHasta.value = true;
        return;
      }
      errorDesdeNoMayorHasta.value = false;

      const diffTime = Math.abs(fHasta - fDesde);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;

      if (diffDays > 31) {
        errorPeriodoMaximo31Dias.value = true;
        return;
      }
      errorPeriodoMaximo31Dias.value = false;

      periodoFiltroDesde.value = periodoFiltroDesdeTemp.value;
      periodoFiltroHasta.value = periodoFiltroHastaTemp.value;
      
      if (newDesde) localStorage.setItem('filtroPeriodoDesdeRRHH', newDesde);
      if (newHasta) localStorage.setItem('filtroPeriodoHastaRRHH', newHasta);

      await fetchResumenSemana();
    };

    const formatearHora = (horaString) => {
      if (!horaString) return '';
      return horaString.substring(0, 5);
    };

    const obtenerHorariosBO = (diaSemanaId, fechaDelDiaStr) => {
      return listaHorariosBackOffice.value
        .filter(h => {
          if (h.Dia !== diaSemanaId && h.Dia !== 0) return false;
          const desde = h.PeriodoDesde ? h.PeriodoDesde.substring(0, 10) : '';
          const hasta = h.PeriodoHasta ? h.PeriodoHasta.substring(0, 10) : '';

          const cumpleDesde = !desde || desde <= fechaDelDiaStr;
          const cumpleHasta = !hasta || hasta >= fechaDelDiaStr;

          return cumpleDesde && cumpleHasta;
        })
        .sort((a, b) => {
          const horaA = a.HoraDesde || "";
          const horaB = b.HoraDesde || "";
          return horaA.localeCompare(horaB);
        });
    };

    const obtenerResumenDia = (fecha) => {
      return resumenSemana.value.find(r => r.Fecha === fecha);
    };

    const fetchResumenSemana = async () => {
      const idUser = props.persona.IdPersona;
      if (!idUser) return;
      
      try {
        const response = await api.get(`api/horarios/fichadas/${idUser}?fechaDesde=${periodoFiltroDesde.value}&fechaHasta=${periodoFiltroHasta.value}`);
        resumenSemana.value = response.data || [];
      } catch (error) {
        console.error('Error al obtener resumen de fichadas:', error);
      }
    };

    const fetchDatos = async () => {
      loading.value = true;
      const idUser = props.persona.IdPersona;

      try {
        const responseBO = await api.get(`api/horarios/backOffice/${idUser}`);
        const dataBO = responseBO.data;
        listaHorariosBackOffice.value = Array.isArray(dataBO) ? dataBO : (dataBO ? [dataBO] : []);
        
        await fetchResumenSemana();
        if (resumenSemana.value.every(rs => rs.Fichadas.length === 0) && listaHorariosBackOffice.value.length === 0) {
          noTieneHorariosNiFichadas.value = true;
        } else {
          noTieneHorariosNiFichadas.value = false;
        }
      } catch (error) {
        console.error('Error al obtener datos:', error);
      } finally {
        loading.value = false;
      }
    };

    const handleHomeOfficeChange = () => {
      if (formData.EsHomeOffice) formData.EsVacaciones = false;
    };

    const handleVacacionesChange = () => {
      if (formData.EsVacaciones) formData.EsHomeOffice = false;
    };

    const abrirModalNuevo = (tipo) => {
      isEditing.value = false;
      const hoy = new Date().toISOString().split("T")[0]; 
      
      formData.IdHorario = null;
      formData.Dia = 0; 
      formData.HoraDesde = null;
      formData.HoraHasta = null;
      formData.PeriodoDesde = hoy; 
      formData.PeriodoHasta = '';  
      formData.EsHomeOffice = false;
      formData.Nombre = tipo;
      
      if (tipo === 'vacaciones') {
        formData.EsVacaciones = true;
        formData.TipoLicencia = null;
      } else if (tipo === 'receso') {
        formData.EsVacaciones = false;
        formData.TipoLicencia = null;
      } else if (tipo === 'licenciaEspecial') {
        formData.EsVacaciones = false;
        formData.TipoLicencia = '';
      } else {
        formData.EsVacaciones = false;
        formData.TipoLicencia = null;
      }

      showModal.value = true;
    };

    const abrirModalEditar = (item) => {
      isEditing.value = true;
      formData.IdHorario = item.IdHorario;
      formData.Dia = item.Dia;
      
      formData.HoraDesde = item.HoraDesde ? item.HoraDesde.substring(0, 5) : null; 
      formData.HoraHasta = item.HoraHasta ? item.HoraHasta.substring(0, 5) : null;
      
      formData.PeriodoDesde = item.PeriodoDesde ? item.PeriodoDesde.substring(0, 10) : '';
      formData.PeriodoHasta = item.PeriodoHasta ? item.PeriodoHasta.substring(0, 10) : '';
      formData.EsHomeOffice = item.EsHomeOffice;
      formData.EsVacaciones = item.EsVacaciones || false;
      formData.TipoLicencia = item.TipoLicencia;
      
      if (item.EsVacaciones) {
        formData.Nombre = 'vacaciones';
      } else {
        formData.Nombre = 'horario';
      }

      showModal.value = true;
    };

    const cerrarModal = () => {
      showModal.value = false;
    };

    const guardarHorario = async () => {
      guardando.value = true;
      const idUser = props.persona.IdPersona; 
      
      const horaDesdeF = formData.HoraDesde?.length === 5 ? `${formData.HoraDesde}:00` : formData.HoraDesde;
      const horaHastaF = formData.HoraHasta?.length === 5 ? `${formData.HoraHasta}:00` : formData.HoraHasta;

      if(formData.HoraDesde > formData.HoraHasta) {
        alert('la Hora Desde no puede ser mayor a la Hora Hasta.');
        guardando.value = false;
        return;
      }

      if(formData.PeriodoDesde > formData.PeriodoHasta && formData.PeriodoHasta !== '') {
        alert('El Periodo Desde no puede ser mayor al Periodo Hasta.');
        guardando.value = false;
        return;
      }

      const basePayload = {
        IdPersona: idUser,
        HoraDesde: horaDesdeF,
        HoraHasta: horaHastaF,
        PeriodoDesde: formData.PeriodoDesde || null,
        PeriodoHasta: formData.PeriodoHasta || null,
        EsHomeOffice: formData.EsHomeOffice,
        EsVacaciones: formData.EsVacaciones,
        TipoLicencia: formData.TipoLicencia || null
      };

      try {
        if (isEditing.value) {
          const payload = { ...basePayload, Dia: formData.Dia, IdHorario: formData.IdHorario };
          await api.put(`api/horarios/backOffice/${formData.IdHorario}`, payload);
        } else {
          let payloads = [];
          if (formData.EsVacaciones || formData.TipoLicencia != null) {
            payloads.push({ ...basePayload, Dia: 0 });
          } else if (formData.Dia === 0) {
            for (let i = 1; i <= 5; i++) {
              payloads.push({ ...basePayload, Dia: i });
            }
          } else {
            payloads.push({ ...basePayload, Dia: formData.Dia });
          }
          await api.post(`api/horarios/backOffice`, payloads);
        }
        
        await fetchDatos();
        cerrarModal();
      } catch (error) {
        console.error('Error al guardar el horario:', error);
        alert('Hubo un error al guardar el horario.');
      } finally {
        guardando.value = false;
      }
    };

    const eliminarHorario = async (idHorario) => {
      if (!confirm(t('¿Está seguro de que desea eliminar este horario?'))) return;
      
      try {
        await api.delete(`api/horarios/backOffice/${idHorario}`);
        listaHorariosBackOffice.value = listaHorariosBackOffice.value.filter(h => h.IdHorario !== idHorario);
      } catch (error) {
        console.error('Error al eliminar:', error);
        alert('Hubo un error al eliminar el horario.');
      }
    };

    watch(
      [periodoFiltroDesdeTemp, periodoFiltroHastaTemp], 
      ([newDesde, newHasta], [oldDesde, oldHasta], onCleanup) => {
        
        const timer = setTimeout(() => {
          aplicarFiltroPersonalizado(newDesde, newHasta, oldDesde, oldHasta);
        }, 1000);

        onCleanup(() => {
          clearTimeout(timer);
        });
        
      }
    );

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; 

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload();
      }
      checkAuth();
      fetchDatos();
    });

    watch(() => props.persona, (nuevaPersona) => {
      if (nuevaPersona) {
         fetchDatos(); 
      }
    }, { deep: true });

    return {
      t,
      loading,
      listaHorariosBackOffice,
      resumenSemana,
      diasSemana,
      reloj,
      formatearHora,
      obtenerHorariosBO,
      obtenerResumenDia,
      showModal,
      isEditing,
      guardando,
      guardandoIds,
      formData,
      abrirModalNuevo,
      abrirModalEditar,
      cerrarModal,
      guardarHorario,
      eliminarHorario,
      onFileSelected,
      eliminarCertificado,
      puedeAvanzar, 
      puedeRetroceder,
      hasVerHorariosPermission,
      hasManejarHorariosPermission,
      hasVerFichadasPermission,
      hasVerMisHorariosYFichadasPermission,
      handleHomeOfficeChange,
      handleVacacionesChange,
      periodoFiltroDesde,
      periodoFiltroHasta,
      periodoFiltroDesdeTemp,
      periodoFiltroHastaTemp,
      aplicarFiltroPersonalizado,
      fechasAVisualizar,
      cambiarPeriodo,
      cantidadColumnas,
      noTieneHorariosNiFichadas,
      errorPeriodoMaximo31Dias,
      errorDesdeNoMayorHasta,
      hasAdminHorariosPermission,
    };
  }
};
</script>

<style scoped>
.modal-backdrop-custom {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
}
</style>